import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CalendarEntry, CalendarEntryStatus } from '@contracts/interfaces/calendar.interface';

@Component({
  selector: 'app-calendar-entry-dialog',
  templateUrl: './calendar-entry-dialog.component.html',
  styleUrls: ['./calendar-entry-dialog.component.scss'],
})
export class CalendarEntryDialogComponent {
  CalendarEntryStatus = CalendarEntryStatus;
  entry: CalendarEntry;
  scheduledAtInput: string;
  isNew: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { entry: CalendarEntry; isNew?: boolean },
    private dialogRef: MatDialogRef<CalendarEntryDialogComponent>
  ) {
    this.entry = { ...data.entry };
    this.scheduledAtInput = this.toInputValue(this.entry.scheduledAt);
    this.isNew = !!data.isNew;
  }

  private toInputValue(date: Date | string): string {
    const baseDate = date ? date : new Date();
    const d = baseDate instanceof Date ? baseDate : new Date(baseDate);
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  }

  save(): void {
    const scheduledAt = this.scheduledAtInput ? new Date(`${this.scheduledAtInput}T00:00:00`) : this.entry.scheduledAt;
    this.dialogRef.close({
      ...this.entry,
      scheduledAt
    } as CalendarEntry);
  }

  deleteEntry(): void {
    if (this.isNew) {
      return;
    }
    this.dialogRef.close({
      delete: true,
      entry: this.entry
    });
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
